import {
  colorFamilies,
  colorFamilyLabels,
  type DesignSystemColorFamily,
  type DesignSystemColorShade,
} from '../tokens/colors'

export type ColorSelectOption = {
  value: DesignSystemColorFamily
  label: string
  /** Token shade used for the menu/trigger swatch. */
  swatchShade: DesignSystemColorShade
}

export type ColorSelectPreviewState =
  | 'default'
  | 'focused'
  | 'filled'
  | 'disabled'
  | 'error'
  | 'expanded'
  | 'with-tooltip'
  | 'optional'
  | 'with-info'

export const COLOR_SELECT_PREVIEW_STATES: ColorSelectPreviewState[] = [
  'default',
  'focused',
  'filled',
  'disabled',
  'error',
  'expanded',
  'with-tooltip',
  'optional',
  'with-info',
]

export const COLOR_SELECT_PREVIEW_STATE_LABELS: Record<
  ColorSelectPreviewState,
  string
> = {
  default: 'Default',
  focused: 'Focused',
  filled: 'Filled',
  disabled: 'Disabled',
  error: 'Error',
  expanded: 'Expanded',
  'with-tooltip': 'With tooltip',
  optional: 'Optional',
  'with-info': 'With info',
}

/** Color state swatch stops per family. */
export const COLOR_SELECT_SWATCH_SHADES: Record<
  DesignSystemColorFamily,
  DesignSystemColorShade
> = {
  gray: 400,
  red: 400,
  orange: 400,
  yellow: 400,
  'lime-green': 400,
  'vivid-green': 400,
  'pale-green': 400,
  teal: 400,
  cyan: 400,
  blue: 500,
  indigo: 500,
  purple: 500,
  pink: 500,
}

export const COLOR_SELECT_DEMO_OPTIONS: ColorSelectOption[] = colorFamilies.map(
  (family) => ({
    value: family,
    label: colorFamilyLabels[family],
    swatchShade: COLOR_SELECT_SWATCH_SHADES[family],
  }),
)

export const COLOR_SELECT_DEMO_LABEL = 'Color'

export const COLOR_SELECT_DEMO_PLACEHOLDER = 'Select'

export const COLOR_SELECT_DEMO_FILLED_VALUE: DesignSystemColorFamily = 'blue'

export const COLOR_SELECT_DEMO_ERROR_MESSAGE = 'Error description'

export const COLOR_SELECT_DEMO_INFO_MESSAGE = 'Info text'

export type ColorSelectProps = {
  label?: string
  placeholder?: string
  options?: ColorSelectOption[]
  value?: DesignSystemColorFamily | ''
  defaultValue?: DesignSystemColorFamily | ''
  disabled?: boolean
  error?: boolean
  helperText?: string
  optional?: boolean
  showTooltip?: boolean
  className?: string
  /** dark-mode palette. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: ColorSelectPreviewState
  onChange?: (value: DesignSystemColorFamily) => void
}
